<!-- Main navbar -->
<div id="header" class="navbar navbar-expand-lg navbar-static shadow" *ngIf="currentUser">
    <div class="container-fluid ps-0">
        <div class="d-flex d-lg-none me-2">
            <button type="button" class="navbar-toggler sidebar-mobile-main-toggle rounded-pill 11">
                <i class="ph-list"></i>
            </button>
        </div>

        <div class="navbar-collapse flex-lg-1 order-2 order-lg-1 collapse" id="navbar_search">
            <div class="list-product">
                <ul class="nav">
                    <li *ngIf="ruleCheckerService.isAllow('booking/overview')" class="nav-item ms-md-1">
                        <a [routerLink]="['/', 'analytics', 'booking']"
                           [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }"
                           class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer menu-header fw-light-bold">
                            <i class="ph ph-chart-line-up me-2"></i>
                            {{ 'sideBar.analytics.bookingStatistics' | translate }}
                        </a>
                    </li>
                    <!--<li class="nav-item ms-md-1">
                        <a [routerLink]="['/', 'booking', 'calendar', 'location', 'overview']"
                           [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }"
                           class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer menu-header fw-light-bold">
                            <i class="ph ph-chart-line me-2"></i>
                            {{ 'Thống kê thực chạy' | translate }}
                        </a>
                    </li>
                    <li class="nav-item ms-md-1">
                        <a [routerLink]="['/', 'booking', 'my-booking']"
                           [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }"
                           class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer menu-header fw-light-bold">
                            <i class="ph ph-chart-bar me-2"></i>
                            {{ 'Thống kê hợp đồng' | translate }}
                        </a>
                    </li>-->
                </ul>
            </div>
        </div>

        <ul class="nav hstack gap-sm-1 flex-row justify-content-end order-1 order-lg-2"
            *ngIf="currentUser">
            <li class="nav-item nav-item-dropdown-lg dropdown">
                <a href="javascript: void(0);" class="navbar-nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <img loading="lazy" alt="" src="./assets/styles/default/images/lang/{{ language }}.png" height="19"/>
                </a>
                <div class="dropdown-menu">
                    <a *ngFor="let lang of languages; let i = index"
                       (click)="changeLang(lang)" class="dropdown-item cursor-pointer">
                        <img loading="lazy" alt="" src="./assets/styles/default/images/lang/{{ lang }}.png" height="19"/> <span
                            class="ms-1">{{ 'common.languages.' + lang | translate }}</span>
                    </a>
                </div>
            </li>


            <li class="nav-item nav-item-dropdown-lg dropdown list-web-app d-none d-sm-block">
                <a href="#" class="navbar-nav-link navbar-nav-link-icon rounded-pill" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="ph-squares-four"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-scrollable-sm wmin-lg-600 p-0">
                    <div class="d-flex align-items-center border-bottom p-3">
                        <h6 class="mb-0">{{ 'common.listApp.title' | translate }}</h6>
                    </div>

                    <div class="row row-cols-1 row-cols-sm-2 g-0">
                        <div class="col-4">
                            <a [href]="listApp.contentInsight.url" target="_blank" class="dropdown-item h-100 text-wrap align-items-start border-end-sm border-bottom p-3">
                                <div>
                                    <img [src]="listApp.contentInsight.image" class="h-40px mb-2" alt="">
                                    <div class="fw-semibold my-1">{{ 'common.listApp.contentInsight.name' | translate }}</div>
                                    <div class="text-muted">
                                        {{ 'common.listApp.contentInsight.description' | translate }}
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-4">
                            <a [href]="listApp.brandsafety.url" target="_blank" class="dropdown-item h-100 text-wrap align-items-start border-bottom p-3">
                                <div>
                                    <img [src]="listApp.brandsafety.image" class="h-40px mb-2" alt="">
                                    <div class="fw-semibold my-1">{{ 'common.listApp.brandsafety.name' | translate }}</div>
                                    <div class="text-muted">
                                        {{ 'common.listApp.brandsafety.description' | translate }}
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-4">
                            <a [href]="listApp.dmp.url" target="_blank" class="dropdown-item h-100 text-wrap align-items-start border-end-sm border-bottom border-bottom-sm-0 rounded-bottom-start p-3">
                                <div>
                                    <img [src]="listApp.dmp.image" class="h-40px mb-2" alt="">
                                    <div class="fw-semibold my-1">{{ 'common.listApp.dmp.name' | translate }}</div>
                                    <div class="text-muted">
                                        {{ 'common.listApp.dmp.description' | translate }}
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-4">
                            <a [href]="listApp.inventoryTrading.url" target="_blank" class="dropdown-item h-100 text-wrap align-items-start rounded-bottom-end p-3">
                                <div>
                                    <img [src]="listApp.inventoryTrading.image" class="h-32px mb-2" alt="">
                                    <div class="fw-semibold my-1">{{ 'common.listApp.inventoryTrading.name' | translate }}</div>
                                    <div class="text-muted">
                                        {{ 'common.listApp.inventoryTrading.description' | translate }}
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </li>

            <li class="nav-item nav-item-dropdown-lg dropdown d-none d-sm-block">
                <a (click)="openFullscreen()" class="navbar-nav-link navbar-nav-link-icon rounded-pill cursor-pointer"
                   matTooltip="{{'common.fullScreen' | translate}}">
                    <i class="ph-corners-out"></i>
                </a>
            </li>

            <li class="nav-item nav-item-dropdown-lg dropdown">
                <a href="#" class="navbar-nav-link align-items-center rounded-pill p-1" data-bs-toggle="dropdown">
                    <div class="status-indicator-container">
                        <img loading="lazy" [src]="imageSrc" class="w-32px h-32px rounded-pill border" alt=""/>
                        <span class="status-indicator bg-success"></span>
                    </div>
                    <span class="d-none d-lg-inline-block mx-lg-2 text-truncate w-100">{{ currentUser.username }}</span>
                </a>

                <div class="dropdown-menu dropdown-menu-end">
                    <a class="dropdown-item cursor-pointer" (click)="openProfile()">
                        <i class="ph-user-circle me-2"></i>
                        {{ 'modules.user.common.profile' | translate }}
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item cursor-pointer" (click)="openLinkGuideDoc()">
                        <i class="ph-file-text me-2"></i>
                        {{ 'modules.user.common.guideDoc' | translate }}
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item cursor-pointer text-white bg-danger" *ngIf="originalUser"
                       (click)="switchOriginalUser()">
                        <i class="ph-arrows-left-right me-2"></i>
                        {{ 'modules.auth.common.buttons.backToUserOriginal' | translate }}
                    </a>
                    <a (click)="logout()" class="dropdown-item cursor-pointer">
                        <i class="ph-sign-out me-2"></i>
                        {{ 'modules.auth.common.buttons.logout' | translate }}
                    </a>
                </div>
            </li>
        </ul>
    </div>
</div>
